var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value)?_c('qrcode',{attrs:{"value":_vm.value,"options":_vm.params}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }